import { Suspense, lazy } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/faq"));

const FAQ = () => {
  return (
    <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
  )
}

export default FAQ